import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IAppState } from '../../../../reducers';
import Column from '../../../../shared/components/atoms/Column';
import CardRow from '../../../../shared/components/molecules/CardRow';
import TextInput from '../../../../shared/components/atoms/TextInput';
import { DDoSProtection } from '../../../types/formFields';
import { updateDDoSProtection } from '../../../actions';

const inputIdentifierPrefix = 'ddos-protection_';

export const Edit: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const ddosProtectionTier = useSelector((state: IAppState) => state.quoteBuilder.quote.ddosProtection);
  // Only show Email2 and Email3 for Tier 2, or 3
  const showAdditionalEmails = ["Tier 2", "Tier 3"].includes(ddosProtectionTier ?? "");

  const dispatch = useDispatch();
  const order = useSelector((state: IAppState) => state.orderBuilder.order);
  const updated = (field: keyof DDoSProtection, value: string): DDoSProtection => ({
    ...order.ddosProtection,
    tier: ddosProtectionTier ?? "",
    [field]: value,
  });

  const onChangeWithUpdate = (field: keyof DDoSProtection, value: string) =>
    dispatch(updateDDoSProtection(updated(field, value)));

  return (
    <CardRow title={``}>
     
      <div className="row no-gutters">
        {/* Reporting Contact */}
        <Column defaultWidth={6} className='pr-5'>
          <p className="mb-2 font-weight-bold">Reporting Contact</p>
          <TextInput
            inputIdentifierPrefix={inputIdentifierPrefix}
            fieldName="reportingEmail1"
            onChange={(e) => onChangeWithUpdate('reportingEmail1', e.target.value)}
            labelText="Email address 1 *"
            value={order.ddosProtection?.reportingEmail1 || ''}
          />
          {showAdditionalEmails && (
            <>
              <TextInput
                inputIdentifierPrefix={inputIdentifierPrefix}
                fieldName="reportingEmail2"
                onChange={(e) => onChangeWithUpdate('reportingEmail2', e.target.value)}
                labelText="Email address 2"
                value={order.ddosProtection?.reportingEmail2 || ''}
              />
              <TextInput
                inputIdentifierPrefix={inputIdentifierPrefix}
                fieldName="reportingEmail3"
                onChange={(e) => onChangeWithUpdate('reportingEmail3', e.target.value)}
                labelText="Email address 3"
                value={order.ddosProtection?.reportingEmail3 || ''}
              />
            </>
          )}
        </Column>

        {/* Portal Access - Disabled for v1 */}
        {false && ( //showAdditionalEmails
          <Column defaultWidth={6}>
            <p className="mb-2 font-weight-bold">Portal Access</p>
            <TextInput
              inputIdentifierPrefix={inputIdentifierPrefix}
              fieldName="portalAccessEmail1"
              onChange={(e) => onChangeWithUpdate('portalAccessEmail1', e.target.value)}
              labelText="Email address 1 *"
              value={order.ddosProtection?.portalAccessEmail1 || ''}
            />
            <TextInput
              inputIdentifierPrefix={inputIdentifierPrefix}
              fieldName="portalAccessEmail2"
              onChange={(e) => onChangeWithUpdate('portalAccessEmail2', e.target.value)}
              labelText="Email address 2"
              value={order.ddosProtection?.portalAccessEmail2 || ''}
            />
            <TextInput
              inputIdentifierPrefix={inputIdentifierPrefix}
              fieldName="portalAccessEmail3"
              onChange={(e) => onChangeWithUpdate('portalAccessEmail3', e.target.value)}
              labelText="Email address 3"
              value={order.ddosProtection?.portalAccessEmail3 || ''}
            />
          </Column>
        )}
      </div>
    </CardRow>
  );
};
